import { BookStructure, RatingType } from '../../../../../shared/enums';

const titleKeys = {
  [RatingType.OUTLINE]: {
    [BookStructure.NARRATIVE_NONFICTION]: 'writerRatingModal.outline.bookStructure1.message',
    [BookStructure.TOPIC_BASED]: 'writerRatingModal.outline.bookStructure2.message',
  },
  [RatingType.SAMPLE]: {
    [BookStructure.NARRATIVE_NONFICTION]: 'writerRatingModal.sample.bookStructure1.message',
    [BookStructure.TOPIC_BASED]: 'writerRatingModal.sample.bookStructure2.message',
  },
  [RatingType.DRAFT]: {
    [BookStructure.NARRATIVE_NONFICTION]: 'writerRatingModal.draft.bookStructure1.message',
    [BookStructure.TOPIC_BASED]: 'writerRatingModal.draft.bookStructure2.message',
  },
};

export default (bookStructure, ratingType) => titleKeys[ratingType][bookStructure];
